import { DeleteRounded } from "@mui/icons-material";
import { Box, Button, Dialog, InputLabel, MenuItem, Select, Stack, TextField, Typography } from "@mui/material";
import axios from "axios";
import NumberTextField from "components/ReusableComponents/NumberTextField";
import { AuthState } from "context/AuthContext";
import { GlobalState } from "context/GlobalContext";
import { inputTypes } from "data/globalData";
import { useEffect, useState } from "react";
import { producAllocTableColumns, productionAllocationTypes } from "../data";
import { parseErrorMessage } from "utils/ErrorFunctions/parseErrorMessage";

const formStack = {
	width: { xs: "80%", sm: "40%", md: "30%" },
};
const colStyle = {
	headerAlign: "center",
	align: "center",
	width: 133,
};

const DataPopup = ({ modal, setModal, selectedProdType, setSelectedProdType, styleProductionRows, setStyleProductionRows }) => {
	const { setSnackBar, snackBar, setSnackBarOpen, setLoadingOpen } = GlobalState();
	const { user } = AuthState();
	const [file, setFile] = useState();

	const handleCloseModal = () => {
		setModal(false);
	};

	const handleCostSheetFileUpload = async (file, publish) => {
		if (!file) {
			if (
				publish &&
				selectedProdType?.production_type === productionAllocationTypes.FOB.key &&
				!selectedProdType?.cost_sheet_url?.length > 0
			) {
				setSnackBarOpen(true);
				setSnackBar({
					...snackBar,
					message: `Select File `,
					severity: "error",
					anchorOrigin: { horizontal: "center", vertical: "top" },
				});
				setLoadingOpen(false);
				return { success: false, url: "" };
			}
		}
		if (file) {
			const formData = new FormData();
			formData.append("file", file);
			const res = await axios.post(`/api/production_allocation/upload_cost_sheet/${selectedProdType?.style_id}`, formData, {
				headers: { "Content-Type": "multipart/form-data" },
			});
			return { success: true, url: res?.data?.result?.url };
		} else return { success: true, url: "" };
	};
	const commonSubmitFunction = async (selectedProdType, fileUrl, publish) => {
		const columnstoSend = [...Object.keys(producAllocTableColumns).map((row) => producAllocTableColumns[row])];
		let body = {
			id: selectedProdType.id,
		};
		columnstoSend?.forEach((row) => {
			body[row?.key] = selectedProdType[row?.key];
		});
		body[producAllocTableColumns.cost_sheet_url.key] = fileUrl
			? fileUrl
			: selectedProdType?.[producAllocTableColumns.cost_sheet_url.key]
			? selectedProdType?.[producAllocTableColumns.cost_sheet_url.key]
			: "";

		await axios.put("/api/production_allocation/update", body).then(async (updateData) => {
			setSnackBarOpen(true);
			setSnackBar({
				...snackBar,
				message: `Data saved Successfully  `,
				severity: "success",
				anchorOrigin: { horizontal: "center", vertical: "top" },
			});
			if (publish) {
				await axios.patch(`/api/production_allocation/publish/${selectedProdType?.id}`).then((res) => {
					console.log(res?.data);
					setStyleProductionRows(
						styleProductionRows?.map((row) => {
							if (row.id === selectedProdType?.id) {
								return {
									...selectedProdType,
									...body,
									...res.data.result,
								};
							} else return row;
						})
					);
					setSnackBarOpen(true);
					setSnackBar({
						...snackBar,
						message: `Published Successfully  `,
						severity: "success",
						anchorOrigin: { horizontal: "center", vertical: "top" },
					});
				});
				handleCloseModal();
				setLoadingOpen(false);
				setSelectedProdType({});
			} else {
				setStyleProductionRows(
					styleProductionRows?.map((row) => {
						if (row.id === selectedProdType?.id) {
							return { ...selectedProdType, ...body };
						} else return row;
					})
				);
				handleCloseModal();
				setLoadingOpen(false);
			}
		});
	};
	const handleFOBSubmit = async (publish) => {
		try {
			const fileUrl = await handleCostSheetFileUpload(file, publish);
			console.log(fileUrl, "dkfbnsfvdh");
			if (fileUrl?.success) await commonSubmitFunction(selectedProdType, fileUrl?.url, publish);
		} catch (error) {
			setSnackBarOpen(true);
			setSnackBar({
				...snackBar,
				message: parseErrorMessage(error),
				severity: "error",
				anchorOrigin: { horizontal: "center", vertical: "top" },
			});
			setLoadingOpen(false);
		}
	};
	const handleJobWorkSubmit = async (publish) => {
		try {
			commonSubmitFunction(selectedProdType, "", publish);
		} catch (error) {
			setSnackBarOpen(true);
			setSnackBar({
				...snackBar,
				message: parseErrorMessage(error),
				severity: "error",
				anchorOrigin: { horizontal: "center", vertical: "top" },
			});
			setLoadingOpen(false);
		}
	};

	const handleFormSubmit = async (publish) => {
		setLoadingOpen(true);
		if (!selectedProdType?.production_type || selectedProdType?.production_type === inputTypes.SELECT.key) {
			setSnackBarOpen(true);
			setSnackBar({
				...snackBar,
				message: `Select Production Type`,
				severity: "error",
				anchorOrigin: { horizontal: "center", vertical: "top" },
			});
			setLoadingOpen(false);
			return;
		}
		if (selectedProdType?.production_type === productionAllocationTypes?.FOB.key) handleFOBSubmit(publish);
		if (selectedProdType?.production_type === productionAllocationTypes?.JOB_WORK.key) handleJobWorkSubmit(publish);
	};

	return (
		<Dialog fullWidth maxWidth="md" open={modal} onClose={handleCloseModal} component="form" onSubmit={handleFormSubmit}>
			<Box width="95%" margin="auto" pt={1} display="flex" flexWrap="wrap" columnGap="2%" rowGap={1}>
				<Typography variant="h6" width="100%">
					Production Data
				</Typography>

				<Stack sx={formStack} spacing={0}>
					<InputLabel htmlFor="companyType">
						Production Type<span>*</span>:
					</InputLabel>
					<Select
						MenuProps={{ PaperProps: { sx: { maxHeight: 200 } } }}
						value={selectedProdType && selectedProdType?.production_type ? selectedProdType.production_type : "select"}
						onChange={(e) => setSelectedProdType({ ...selectedProdType, production_type: e.target.value })}
						size="small"
						required>
						<MenuItem value="select">Select</MenuItem>
						{Object.keys(productionAllocationTypes).map((row) => {
							return (
								<MenuItem value={productionAllocationTypes[row].key}>{productionAllocationTypes[row].name}</MenuItem>
							);
						})}
					</Select>
				</Stack>
				{selectedProdType && selectedProdType?.production_type === productionAllocationTypes.FOB.key ? (
					<>
						<Stack sx={formStack} spacing={0}>
							<InputLabel htmlFor="companyType">Cost</InputLabel>
							<NumberTextField
								variant="outlined"
								// sx={}
								size="small"
								disableHelperText
								disabled={false}
								onChange={(e) => setSelectedProdType({ ...selectedProdType, cost_rate: e.target.value })}
								value={selectedProdType?.cost_rate ? selectedProdType?.cost_rate : 0}
							/>
						</Stack>
						<Box width="100%" mt={2}>
							<Box key={selectedProdType} display="flex" columnGap={2} alignItems="center">
								<Typography variant="h6" fontSize={18}>
									Cost Sheet
								</Typography>
								{selectedProdType && (
									<a
										href={selectedProdType?.[producAllocTableColumns.cost_sheet_url.key]}
										target="_blank"
										rel="noreferrer">
										{selectedProdType?.[producAllocTableColumns.cost_sheet_url.key]?.length > 0 ? "Download" : ""}
									</a>
								)}
							</Box>
							<Stack sx={formStack} spacing={0}>
								<InputLabel>{selectedProdType?.url ? "Update cost sheet" : "Upload Cost Sheet"}</InputLabel>
								<TextField
									variant="outlined"
									// sx={}
									size="small"
									disableHelperText
									type="file"
									disabled={false}
									onChange={(e) => setFile(e.target.files[0])}
									// value={selectedProdType?.cost_rate ? selectedProdType?.cost_rate : 0}
								/>
							</Stack>
						</Box>
					</>
				) : (
					<></>
				)}
			</Box>

			<Stack width="95%" margin="auto" p={1}>
				<Box marginLeft="auto" display="flex" columnGap={1}>
					<Button size="small" variant="outlined" onClick={handleCloseModal}>
						Cancel
					</Button>
					<Button size="small" variant="contained" onClick={() => handleFormSubmit(true)}>
						Publish
					</Button>
					<Button size="small" variant="contained" onClick={() => handleFormSubmit(false)}>
						Save
					</Button>
				</Box>
			</Stack>
		</Dialog>
	);
};

export default DataPopup;
